import { render, staticRenderFns } from "./marketLease.vue?vue&type=template&id=8c8bc8c6&scoped=true&"
import script from "./marketLease.vue?vue&type=script&lang=js&"
export * from "./marketLease.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c8bc8c6",
  null
  
)

export default component.exports